<template>
  <div style="
      align-items: stretch;
      display: flex;
      flex-direction: column;
      outline: none;
      overflow-y: hidden;
      position: relative;
      z-index: 10;
    ">
    <div v-if="iconUIType == 'yt-shorts-feed'">
      <div style="
          max-height: 2.5em;
          -webkit-line-clamp: 2;
          overflow: hidden;
          line-height: 1.25;
          text-overflow: ellipsis;
          font-weight: normal;
          padding-left: 8px;
          display: flex;
        ">
        <div style="
            line-height: 10px;
            margin-top: auto;
            line-height: 10px;
            margin-bottom: auto;
            vertical-align: middle;
          ">
          <play-colored :brandingColor="brandingColor"></play-colored>
        </div>
        <span style="
            padding-left: 6px;
            font-size: 16px;
            line-height: 2rem;
            letter-spacing: 0.01em;
            font-weight: 500;
            font-family: -apple-system;
          ">
          ショート
        </span>
      </div>
      <div style="
          width: auto;
          overflow: auto hidden;
          display: flex;
          flex-direction: row;
          flex-shrink: 0;
          height: 272px;
          -webkit-overflow-scrolling: touch;
          margin-top: 10px;
          padding-left: 8px;
          padding-right: 8px;
        " class="syncc-stories-feed__disable-scrollbars-smw0M4cssd">
        <div style="
            position: relative;
            display: flex;
            flex-direction: row;
            padding-left: 0px;
          ">
          <transition-group name="fade" tag="div">
            <div v-for="(icon, index) in iconList" :key="icon.src" v-show="videoContainerShow" :style="[
      styles.iconContainerStyle,
      resolveIconPositionByTabIndex(index),
    ]" class="syncc-stories-feed__yt-style-icon-container-cncL2d94P9">
              <img class="syncc-stories-feed__icon-image-LL4dks89vb" :class="{
      'syncc-stories-feed__icon-image-last-prop-9Wi23mOd':
        index === iconList.length - 1,
    }" :style="styles.iconStyle" :src="icon.src" :alt="'syncc-stories-feed-icon-' + index"
                @load="imageLoaded" v-on:click.prevent="conversionVideo(icon.partId)" />
              <div class="syncc-stories-feed__yt-style-icon-title-container-cnl39dff0a"
                v-on:click.prevent="conversionVideo(icon.partId)">
                <div style="
                    white-space: nowrap;
                    text-align: start;
                    text-overflow: ellipsis;
                    letter-spacing: 0.01em;
                    max-width: 148px;
                    font-size: 12px;
                    font-weight: 500;
                    box-sizing: border-box;
                    overflow-x: hidden;
                    overflow: hidden;
                    color: #fff;
                    white-space: normal;
                    max-height: 54px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;
                  ">
                  {{ icon.title }}
                </div>
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
    <div v-else-if="iconUIType == 'ig-stories-feed'">
      <div style="
          max-height: 2.5em;
          -webkit-line-clamp: 2;
          overflow: hidden;
          line-height: 1.25;
          text-overflow: ellipsis;
          font-weight: normal;
          padding-left: 8px;
          display: flex;
        ">
        <div style="
            line-height: 10px;
            margin-top: auto;
            line-height: 10px;
            margin-bottom: auto;
            vertical-align: middle;
          ">
          <play-colored :brandingColor="brandingColor"></play-colored>
        </div>
        <span style="
            padding-left: 6px;
            font-size: 16px;
            line-height: 2rem;
            letter-spacing: 0.01em;
            font-weight: 500;
            font-family: -apple-system;
          ">
          ストーリーズ
        </span>
      </div>
      <div style="
          width: auto;
          overflow: auto hidden;
          display: flex;
          flex-direction: row;
          flex-shrink: 0;
          height: 120px;
          -webkit-overflow-scrolling: touch;
          margin-top: 10px;
          padding-left: 8px;
          padding-right: 8px;
        " class="syncc-stories-feed__disable-scrollbars-smw0M4cssd">
        <div style="
            position: relative;
            display: flex;
            flex-direction: row;
            padding-left: 0px;
          ">
          <transition-group name="fade" tag="div">
            <div v-for="(icon, index) in iconList" :key="icon.src" v-show="videoContainerShow" :style="[
      styles.iconContainerStyle,
      resolveIconPositionByTabIndex(index),
    ]" class="syncc-stories-feed__ig-style-icon-container-dk3BNekxxs">
              <img class="syncc-stories-feed__icon-image-LL4dks89vb" :class="{
      'syncc-stories-feed__icon-image-last-prop-9Wi23mOd':
        index === iconList.length - 1,
    }" :style="styles.iconStyle" :src="icon.src" :alt="'syncc-stories-feed-icon-' + index"
                @load="imageLoaded" v-on:click.prevent="conversionVideo(icon.partId)" />
              <div style="font-family: -apple-system; margin-top: 6px"
                v-on:click.prevent="conversionVideo(icon.partId)">
                <div style="
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    max-width: 80px;
                    font-size: 12px;
                    font-weight: 500;
                    box-sizing: border-box;
                    overflow-x: hidden;
                    text-align: center;
                  ">
                  {{ icon.title }}
                </div>
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
    <!--- Preload video if needed -->
    <!---
    <interactive-video
      id="preloadVideoContainer"
      :partId="initialPartData.partId"
      :currentSelectedVideo="false"
      :playbackId="initialPartData.video.mux_playback_id"
      :jwt="initialPartData.video.mux_jwt"
      :videoThumbnailSrc="initialPartData.videoThumbnailSrc"
      style="display: none; width: 1px; height: 1px"
    >
    </interactive-video>
    -->
  </div>
</template>

<script>
import Config from "../models/Config";
import Customization from "../models/Customization";
import Part from "../models/Part";
import PartOrder from "../models/PartOrder";
import Story from "../models/Story";
import Video from "../models/Video";

import PlayColored from "../components/UI/icons/svg/PlayColored.vue";
import InteractiveVideo from "../components/UI/InteractiveVideo.vue";
import CloseBtn from "../components/UI/CloseBtn.vue";
import TextBubble from "../components/UI/TextBubble.vue";

export default {
  components: {
    PlayColored,
    CloseBtn,
    TextBubble,
    InteractiveVideo,
  },
  props: {},
  data() {
    return {
      iconList: [],
      iconLoadedCount: 0,
      videoContainerShow: false,
      initialPartData: {},
      textBubbleContent: "",
      iconUIType: "",
      brandingColor: "",
      styles: {
        iconContainerStyle: {},
        iconStyle: {},
      },
    };
  },
  mounted() { },
  created() {
    const parts = Part.all();
    const videos = Video.all();
    let config = Config.all()[0];
    for (var i = 0; i < parts.length; i++) {
      const video = videos[i];
      let iconPlaybackId = video.mux_playback_id;
      let iconGifJWT = video.mux_jwt_for_gif;
      let iconImgJwt = video.mux_jwt_for_img;
      const iconSrc = parts[i].thumbnail
        ? parts[i].thumbnail
        : config.icon_loop
          ? "https://image.mux.com/" +
          iconPlaybackId +
          "/animated.gif?token=" +
          iconGifJWT
          : "https://image.mux.com/" + iconPlaybackId + "?token=" + iconImgJwt;
      this.iconList.push({
        partId: parts[i].$id,
        title: parts[i].title,
        src: iconSrc,
      });

      const nextPartIndex = i + 1;
      const previousPartIndex = i - 1;
      const partOrder = {
        current_part_id: parts[i].$id,
        previous_part_id:
          previousPartIndex >= 0 ? parts[previousPartIndex].$id : "",
        next_part_id:
          nextPartIndex <= videos.length - 1 ? parts[nextPartIndex].$id : "",
        is_initial_part: i == 0,
        is_last: i == videos.length - 1,
      };
      PartOrder.insert({ data: partOrder });
    }

    this.initialPartData = {
      partId: parts[0].part_id,
      part: parts[0],
      video: videos[0],
      videoThumbnail: config.icon_loop
        ? "https://image.mux.com/" +
        videos[0].mux_playback_id +
        "/animated.gif?fps=15&width=640&height=640&start=2.5&token=" +
        videos[0].mux_jwt_for_gif
        : "https://image.mux.com/" +
        videos[0].mux_playback_id +
        "?token=" +
        videos[0].mux_jwt_for_img,
    };

    let customization = Customization.all()[0];

    const defaultBorderColor = `-webkit-linear-gradient(left top, #b827fc 0%, #2c90fc 30%, #b8fd33 50%, #fec837 60%, #fd1892 100%)`;
    const iconBorderColor =
      customization.icon_border == "DEFAULT"
        ? defaultBorderColor
        : customization.icon_border == "CUSTOM"
          ? customization.theme_color
          : "none";

    this.brandingColor = customization.theme_color
      ? customization.theme_color
      : "#31AFB4";

    this.styles.iconContainerStyle = {
      "-webkit-user-select": "none",
      position: "absolute",
      left: 0,
      margin: "auto",
      "z-index": "999 !important",
    };

    let storyUIType = customization.stories_feed_ui_type;
    if (storyUIType == "YT_STYLE_SHORT_VIDEO_UI") {
      this.iconUIType = "yt-shorts-feed";
    } else if (storyUIType == "IG_STYLE_STORIES_VIDEO_UI") {
      this.iconUIType = "ig-stories-feed";
    } else {
      // TOOD(manabe): 以下に変更
      // this.iconUIType = "ig-stories-feed";
      this.iconUIType = "yt-shorts-feed";
    }

    this.styles.iconStyle =
      this.iconUIType == "ig-stories-feed"
        ? {
          width: "100%",
          height: "100%",
          transition: "background-color 300ms; border-radius 300ms",
          objectFit: "cover",
          borderRadius: "50%",
          zIndex: "997 !important",
          cursor: "pointer",
          "clip-path": "circle(43%) !important",
          background: iconBorderColor,
        }
        : {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "10px",
          zIndex: "997 !important",
          cursor: "pointer",
        };
  },
  beforeDestroy() { },
  watch: {},
  computed: {},
  methods: {
    imageLoaded() {
      this.iconLoadedCount++;
      if (this.iconLoadedCount == this.iconList.length) {
        this.videoContainerShow = true;
      }
    },
    disposeIcon() {
      // FIXME: エラー発生箇所
      let iconEl = document.getElementById("video-icon");
      iconEl.removeAttribute("src"); // empty source
      iconEl.load();
    },
    resolveIconPositionByTabIndex(iconSrcListIndex) {
      const spaceCriteria = this.iconUIType == "yt-shorts-feed" ? 160 : 90;
      const position = spaceCriteria * iconSrcListIndex + "px";
      return {
        transform: "translateX(" + position + ")",
      };
    },
    conversionVideo(videoPartId) {
      this.$router.push({
        name: "story-videos",
        params: {
          id: videoPartId,
        },
      });
    },
  },
};
</script>

<style scoped>
.syncc-stories-feed__welcome-icon-close-btn-LdeN298b {
  position: absolute;
  top: 5px !important;
  right: 4px !important;
  z-index: 997 !important;
  cursor: pointer;
}

.syncc-stories-feed__notification-badge-circle-6L2doxp {
  position: absolute;
  top: 7px !important;
  right: 7px !important;
  z-index: 998 !important;
  padding: 12px 12px;
  border-radius: 50%;
  background: #ff4c51;
  color: white;
}

.syncc-stories-feed__notification-badge-rectangle-6L2doxp {
  position: absolute;
  top: -5px !important;
  right: -4px !important;
  z-index: 998 !important;
  padding: 12px 12px;
  border-radius: 50%;
  background: #ff4c51;
  color: white;
}

.syncc-stories-feed__notification-badge-none-6L2doxp {
  display: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.syncc-stories-feed__zoom-content--storyicon-4aqmLwncEr {
  zoom: 100%;
}

@-moz-document url-prefix() {

  /* For firefox */
  .syncc-stories-feed__zoom-content--storyicon-4aqmLwncEr {
    transform-origin: 0 0;
    transform: scale(1);
  }
}

@media screen and (max-width: 767px) {
  .syncc-stories-feed__zoom-content--storyicon-4aqmLwncEr {
    zoom: 45%;
  }

  @-moz-document url-prefix() {

    /* For firefox */
    .syncc-stories-feed__zoom-content--storyicon-4aqmLwncEr {
      transform-origin: 0 0;
      transform: scale(0.45);
    }
  }
}
</style>